import { render, staticRenderFns } from "./CommonReference.vue?vue&type=template&id=12a2b5d6&"
import script from "./CommonReference.vue?vue&type=script&lang=js&"
export * from "./CommonReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports